module.exports = __webpack_public_path__ + "static/img/friend4.addcd8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend4.png
// module id = Xoqg
// module chunks = 1